<template>
    <div :class="'pill ' + color">
        {{ text }}
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Pill',
    components: {},
    props: {
        text: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: '',
        },
    },
});
</script>

<style lang="postcss" scoped>
.pill {
    @apply rounded-full py-1 px-2 inline-block text-sm font-medium bg-grey-300 text-grey-300 bg-opacity-25 border-none capitalize;

    &.blue {
        @apply bg-blue-400 text-blue-400 bg-opacity-25;
    }

    &.red {
        @apply bg-red-600 text-red-600 bg-opacity-25;
    }
}
</style>
